import React from 'react';
import { motion } from 'framer-motion';
export function TomosGrid() {
  const tomos = [{
    id: 1,
    color: 'bg-emerald-500',
    lightColor: 'bg-emerald-50',
    borderColor: 'border-emerald-200',
    textColor: 'text-emerald-700',
    emoji: '🟢',
    title: 'Cimientos',
    subtitle: 'Base Sólida',
    desc: 'Parámetros del LSA, abecedario dactilológico, números, saludos y presentación completa.'
  }, {
    id: 2,
    color: 'bg-yellow-400',
    lightColor: 'bg-yellow-50',
    borderColor: 'border-yellow-200',
    textColor: 'text-yellow-700',
    emoji: '🟡',
    title: 'Vínculos',
    subtitle: 'Familia y Emociones',
    desc: 'Familia completa, las 30 emociones fundamentales, el tiempo, días, meses y clima.'
  }, {
    id: 3,
    color: 'bg-orange-500',
    lightColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
    textColor: 'text-orange-700',
    emoji: '🟠',
    title: 'Inmersión Diaria',
    subtitle: 'La Vida Cotidiana',
    desc: 'El hogar, los alimentos argentinos, la ropa, la ciudad, rutinas y comercios.'
  }, {
    id: 4,
    color: 'bg-blue-500',
    lightColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
    textColor: 'text-blue-700',
    emoji: '🔵',
    title: 'El Mundo Exterior',
    subtitle: 'Contextos Formales',
    desc: 'Trabajo, salud, tecnología, trámites, educación y tiempo libre.'
  }, {
    id: 5,
    color: 'bg-purple-500',
    lightColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
    textColor: 'text-purple-700',
    emoji: '🟣',
    title: 'Profundidad',
    subtitle: 'Gramática y Cultura Sorda',
    desc: 'Gramática avanzada, clasificadores, narrativa, cultura Sorda argentina y variaciones regionales.'
  }, {
    id: 6,
    color: 'bg-amber-400',
    lightColor: 'bg-amber-50',
    borderColor: 'border-amber-200',
    textColor: 'text-amber-700',
    emoji: '⭐',
    title: 'Maestría',
    subtitle: 'Integración y Diccionario Visual',
    desc: 'Situaciones complejas, el señante consciente, el diccionario visual de 500+ señas y el camino hacia la fluidez.'
  }];
  return <section className="py-20 bg-slate-900" data-id="element-326">
      <div className="container mx-auto px-4" data-id="element-327">
        <div className="text-center mb-16" data-id="element-328">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sky-500/20 text-sky-300 border border-sky-500/30 font-bold mb-6" data-id="element-329">
            🤟 CENTRALPACK™ MEGAPACK LSA LISTO
          </div>
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-4" data-id="element-330">
            6 Tomos + 4 Bonos
          </h2>
          <p className="text-slate-300 font-medium text-[18px]" data-id="element-331">
            Del cero a la conversación real. 360+ páginas — Todo resuelto.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto" data-id="element-332">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className={`rounded-2xl border border-slate-700 bg-slate-800/60 overflow-hidden shadow-lg hover:shadow-xl hover:border-slate-600 transition-all flex flex-col h-full`} data-id="element-333">
              <div className={`bg-slate-900/80 p-4 border-b border-slate-700 flex items-center gap-3`} data-id="element-334">
                <div className="text-2xl" data-id="element-335">{tomo.emoji}</div>
                <div data-id="element-336">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor.replace('700', '400')}`} data-id="element-337">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-338">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-339">
                <p className="font-semibold text-slate-200 mb-3 pb-3 border-b border-slate-700" data-id="element-340">
                  {tomo.subtitle}
                </p>
                <p className="text-slate-400 text-sm leading-relaxed" data-id="element-341">
                  {tomo.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}